import getConfig from "next/config";
import Link from "next/link";

import Heading from "@components/Heading";
import ArrowRight from "@components/Icons/ArrowRight";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const AppleCategoryCard = ({ category }) => (
  <>
    <Heading
      as="h2"
      title={
        <Link href={category.url}>
          <a
            title=""
            className="flex gap-[6px] items-center text-[#121212] text-[18px] md:text-[22px] leading-[20px] -tracking-[0.28px]"
          >
            {category.name} <ArrowRight />
          </a>
        </Link>
      }
    />

    <div className="py-[30px] px-[20px] my-auto">
      <Link href={category.url}>
        <a title="">
          <img src={`${settings.cdn}${category.image}`} alt="" />
        </a>
      </Link>
    </div>
  </>
);

export default AppleCategoryCard;
